'use strict';

/**
 * All JS for any action of the CurriculaVitae on the server side
 */
waApp.controllers.CurriculaVitae = {
	_addAndEdit: function() {
		$('input[name="cancel"]').on('click', function(e) {
			$('#cv-form').attr('novalidate', 'novalidate');
		});

		$('#preview-button').on('click', function(event) {
			event.preventDefault();

			let language = waApp.getLanguage();
			let formData = $('#cv-form').serialize();

			$.post('/' + language + '/curricula-vitae/preview', formData)
				.done(function(data) {
					$('#cv-form-container').hide();
					$('#preview').html(data);
					$('#preview').show();
					$('html,body').scrollTop(0);
				});
		});

		$('#preview').on('click', '#preview-back-button', function(event) {
			event.preventDefault();

			$('#preview').hide();
			$('#cv-form-container').show();
		});
	},
	add: function() {
		waApp.controllers.CurriculaVitae._addAndEdit();
	},
	edit: function() {
		waApp.controllers.CurriculaVitae._addAndEdit();
	}
};
